import { useProgrammatic } from '@oruga-ui/oruga-next';
import NotificationMessage from '@/components/NotificationMessage.vue';

const {oruga} = useProgrammatic();

export default function NotificationSuccess(config: any) {
  const {message, ...options} = config;

  oruga.notification.open({
    position: 'top-right',
    variant: 'success',
    duration: 5000,
    component: NotificationMessage,
    props: {
      message: message || 'Success',
    },
    ...options,
  });
};
